// MongoDB Service - Using http://mongo.somm.ai/api/db (replaces deprecated Stitch)
class MongoService {
  constructor() {
    // Use your MongoDB API server directly
    this.baseUrl = process.env.REACT_APP_API_URL || 'https://mongo.somm.ai';
    
    // Basic authentication credentials from environment variables
    this.username = process.env.REACT_APP_MONGO_USERNAME;
    this.password = process.env.REACT_APP_MONGO_PASSWORD;
  }

  async mongoRequest(collection, operation, query = {}, options = {}, pipeline = null) {
    try {
      const body = {
        database: 'mrsomm',
        collection,
        operation,
        query: operation === 'aggregate' ? pipeline : query,
        options
      };

      // Prepare headers
      const headers = {
        'Content-Type': 'application/json',
      };

      // Add Basic Authentication if credentials are provided
      if (this.username && this.password) {
        const credentials = btoa(`${this.username}:${this.password}`);
        headers['Authorization'] = `Basic ${credentials}`;
      }

      const response = await fetch(`${this.baseUrl}/api/db`, {
        method: 'POST',
        headers,
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      
      if (!result.success) {
        throw new Error(result.error || 'API request failed');
      }

      return result.data;
    } catch (error) {
      console.error('MongoDB Service error:', error);
      throw error;
    }
  }

  // Legacy compatibility methods to match Stitch API - keeps all your complex logic here!
  db(dbName) {
    return {
      collection: (collectionName) => {
        return {
          find: (query, options = {}) => ({
            toArray: () => this.mongoRequest(collectionName, 'find', query, options)
          }),
          findOne: (query, options = {}) => this.mongoRequest(collectionName, 'findOne', query, options),
          aggregate: (pipeline) => ({
            toArray: () => this.mongoRequest(collectionName, 'aggregate', {}, {}, pipeline)
          }),
          countDocuments: (query = {}) => this.mongoRequest(collectionName, 'countDocuments', query)
        };
      }
    };
  }
}

// Create singleton instance
const mongoService = new MongoService();

export default mongoService;
